import { render, staticRenderFns } from "./ChatBase.vue?vue&type=template&id=9fe12d42&scoped=true&"
import script from "./ChatBase.vue?vue&type=script&lang=js&"
export * from "./ChatBase.vue?vue&type=script&lang=js&"
import style0 from "./ChatBase.vue?vue&type=style&index=0&id=9fe12d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe12d42",
  null
  
)

export default component.exports